<template>
    <div>
        <solicitacoes-aditivos
            :solicitacoesAditivos="solicitacoesAditivos"
            :solicitacoesAditivosServicos="obterSolicitacoesAditivosServicos()"
            @atualizar-status-selecionado="statusSelecionado = $event"
            @atualizar-listagem="obterSolicitacoesAditivos()"
        ></solicitacoes-aditivos>
        <router-view></router-view>
    </div>
</template>

<script>
import SolicitacoesAditivosServicos from './SolicitacoesAditivosServicos'
import SolicitacoesAditivos from '../../componentes/solicitacoesAditivos/SolicitacoesAditivos'

export default {
    components: {
        SolicitacoesAditivos
    },
    data() {
        return {
            solicitacoesAditivos: [],
            statusSelecionado: 0
        }
    },
    methods: {
        obterSolicitacoesAditivos() {
            this.$store.dispatch('addRequest')
            SolicitacoesAditivosServicos.obterTodas(
                this.statusSelecionado
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.solicitacoesAditivos = response.data
                    } else {
                        this.erros = [
                            'Erro ao obter as solicitações de aditivo'
                        ]
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterSolicitacoesAditivosServicos() {
            return SolicitacoesAditivosServicos
        }
    },

    created() {
        this.obterSolicitacoesAditivos()
    },

    computed: {},

    watch: {
        statusSelecionado() {
            this.obterSolicitacoesAditivos()
        }
    }
}
</script>
